import React          from 'react';
import RadioComponent from './RadioComponent';

const HasArray = (props) => {
  const name = 'has_array';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="has-array-section">
      <strong className="title">I would like to receive my PCBs</strong>
      <div className="row g-0 has-array">
        <div className="col-sm-6 col-lg-12 col-xl-6">
          <RadioComponent
            name={name}
            label="Individually"
            value="0"
            checked={props.parameters[name] === '0'}
            onChange={props.onChange || onChange}
            className="individually"
            inputClassName="has-array-no"
            inputId="has-array-no"
            groupName={props.groupName} />
        </div>
        <div className="col-sm-6 col-lg-12 col-xl-6">
          <RadioComponent
            name={name}
            label="Panelized"
            value="1"
            checked={props.parameters[name] === '1'}
            onChange={props.onChange || onChange}
            className="panelized"
            inputClassName="has-array-yes"
            inputId="has-array-yes"
            groupName={props.groupName} />
        </div>
      </div>
    </div>
  );
};

HasArray.defaultProps = {};

export default HasArray;
